import * as React from "react";
import { Spin } from "antd";
import DataGrid from "../app/grid/DataGrid";
import { IEvaluationBusinessRule } from "../../../model/evaluation/EvaluationBusinessRule";

export interface Props {
  translate: any;
  evaluationBusinessRules: IEvaluationBusinessRule[];
  isLoading: boolean;
}

export interface State {}

export default class EvaluationBusinessRulesGrid extends React.Component<
  Props,
  State
> {
  render() {
    const { translate, evaluationBusinessRules, isLoading } = this.props;

    const coumns = [
      {
        title: translate("evaluation_business_rules_grid.name"),
        dataIndex: "businessRuleName",
        key: "businessRuleName"
      },
      {
        title: translate("evaluation_business_rules_grid.description"),
        dataIndex: "businessRuleDescription",
        key: "businessRuleDescription"
      },
      {
        title: translate("evaluation_business_rules_grid.difficulty_factor"),
        dataIndex: "evaluationBusinessRuleDifficultyFactor",
        key: "evaluationBusinessRuleDifficultyFactor"
      },
      {
        title: translate("evaluation_business_rules_grid.result"),
        dataIndex: "evaluationBusinessRuleResult",
        key: "evaluationBusinessRuleResult"
      },
      {
        title: translate("evaluation_business_rules_grid.error_log"),
        dataIndex: "errorLog",
        key: "errorLog"
      }
    ];
    return (
      <Spin spinning={isLoading}>
        <DataGrid
          title={translate("evaluation_business_rules_grid.title")}
          columns={coumns}
          translate={translate}
          dataSource={evaluationBusinessRules}
        />
      </Spin>
    );
  }
}
